import { render } from "./Research.vue?vue&type=template&id=7552b6a5&scoped=true&ts=true"
import script from "./Research.vue?vue&type=script&lang=ts"
export * from "./Research.vue?vue&type=script&lang=ts"

import "./Research.vue?vue&type=style&index=0&id=7552b6a5&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7552b6a5"]])

export default __exports__